module.exports = __webpack_public_path__ + "img/boat_1.0b73a69b.svg";